import * as React from 'react'
import { ActivityIndicator, Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import theme from '@theme/Theme'

interface Props {
  color?: ButtonColor
  label: string
  onClick: () => void
  status: ButtonStatus
}

const Button = ({ color = 'default', label, onClick, status }: Props) => {
  return (
    <>
      <Container activeOpacity={0.9} color={color} disabled={status !== 'active'} onPress={onClick}>
        <Label numberOfLines={2} ellipsizeMode="tail" color={color}>
          {label}
        </Label>
      </Container>
      {status !== 'active' && (
        <DisabledOverlay>
          {status === 'loading' && <ActivityIndicator color={theme.colors.primary} size={25} />}
        </DisabledOverlay>
      )}
    </>
  )
}

export default Button

const Container = styled(TouchableOpacity)<{ color: ButtonColor }>`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 0 8px;
  border-radius: 4px;
  background-color: ${(props) =>
    props.color === 'light' ? props.theme.colors.primaryLight : props.theme.colors.primary};
  z-index: -1;
  overflow: hidden;
`
const Label = styled(Text)<{ color: ButtonColor }>`
  ${(props) => props.theme.fonts.Callout};
  color: ${(props) => (props.color === 'light' ? props.theme.colors.primary : props.theme.colors.background)};
  text-align: center;
`

const DisabledOverlay = styled(View)`
  position: absolute;
  align-self: center;
  z-index: 1;
  height: 100%;
  width: 100%;
  background-color: rgb(255 255 255 / 70%);
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`
